module.exports = __webpack_public_path__ + "static/img/list-amaraViewFullFaceMask.061a996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-amaraViewFullFaceMask.png
// module id = R0K1
// module chunks = 1